import DocumentsListView from "../../../../components/modules/documentsListView/DocumentsListView";

export default function ViewDocumentDetail() {
  return <DocumentsListView />;
}
